<style scoped lang="scss">
@import "../../common/styles/var";

.sidebar {
  display: block;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  overflow-y: auto;
  overflow-x: auto;
  width: 210px;
  background: #001529;

  &.collapse {
    width: 64px;
  }
}

.ava {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.el-menu {
  border-right: 0 none;
  background: #001529;
}

.sidebar-el-menu:not(.el-menu--collapse) {
  width: 210px;
}

.el-menu-item {
  color: white;
}

.el-menu-item.is-active {
  background: $mainColor;
  color: white;
  border-left: 2px solid $mainColor;
}

</style>

<template>
  <div class="sidebar" :class="{collapse:collapse}">
    <!--loginInfo-->
    <div class="doc-info flex column aic jcc pt15 pb15" :style="{backgroundColor:leftBg}">
      <el-image class="ava" :src="loginInfo.avatarUrl">
        <img slot="error" src="/gjhlwyy/static/img/doctor.m.png" class="ava"/>
      </el-image>
      <template v-if="collapse===false">
        <p class=" fs16 mt10 color_fff">
          <b>{{ loginInfo.staffName }}</b>
        </p>
        <p class="fs14 mt5 flex color_fff">
          <span>{{ loginInfo.staffType === "HEAL_T_ADM" ? "体检团队管理员" : userTypeFilter(loginInfo.staffType) }}</span>
        </p>
        <p class="mt5 fs14 color_fff">
          {{ loginInfo.hosName }}
        </p>
        <p class="mt5 fs14 color_fff">
          {{ loginInfo.aidDeptName }}
        </p>
        <p class="mt5 fs14 color_fff" v-if="loginTeam.teamName" @click="change">
          {{ loginTeam.teamName }} <i class="el-icon-arrow-right"></i>
        </p>
      </template>
    </div>
    <el-menu class="sidebar-el-menu"
             v-if="menuList.length"
             :default-active="onRoutes" :collapse="collapse"
             unique-opened
             router>
      <template v-for="(item,ii) in menuList">
        <template v-if="item.subMenu">
          <el-submenu :index="item.menuUrl" :key="'sub'+item.ii">
            <template slot="title">
              <i :class="item.iconName" class="iconfont mr5"></i><span
                slot="title">{{ item.menuName }}</span>
            </template>
            <el-menu-item v-for="(subItem,i) in item.subMenu" :key="'son'+i" :index="subItem.menuUrl">
              {{ subItem.menuName }}
            </el-menu-item>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.menuUrl" :key="'menu'+ii">
            <i :class="item.iconName" class="iconfont mr5"></i><span slot="title">{{ item.menuName }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
    <choose-team-dialog ref="teamChoose" @submit="changed"></choose-team-dialog>
  </div>
</template>

<script>
import {LEFT_BG} from "../lib/config";
import {loginInfoCache} from "../lib/cache/LoginInfo";
import {AppMixin} from "../lib/mixins/app";
import ChooseTeamDialog from "@/modules/account/components/choose-team-dialog";
import {loginTeamCache} from "@/common/lib/cache/LoginTeam";
import {equalTrue, makeFullURL, queryHasEmergencyReferral} from "@/common/lib/utils";
import menuList from "@/common/lib/menuList";
import {userTypeFilter} from "../lib/filters";

export default {
  name: 'side-bar',
  components: {ChooseTeamDialog},
  mixins: [AppMixin],
  data() {
    return {
      leftBg: LEFT_BG,
      collapse: false,
      items: [],
      menuList: [],
    }
  },
  computed: {
    staffOrderInfo() {
      return this.$store.state.staff.orderInfo || {};
    },
    onRoutes() {
      const {staffOrderInfo} = this;
      let {path, query} = this.$route;
      if (path !== '/staff/detail') return path;
      // staff/detail 页面单独处理
      if ((staffOrderInfo && staffOrderInfo.consultId) || !queryHasEmergencyReferral(query)) { // 远程会诊
        if (query.aspectUser === 'init') return '/staff/consult/faqi';
        else return '/staff/consult/jieshou'
      } else {// 急救
        if (query.aspectUser === 'init') return '/staff/faqi';
        else return '/staff/jieshou'
      }
    }
  },
  created() {
    this.loginInfo = loginInfoCache.get() || {};
    this.loginTeam = loginTeamCache.get() || {};
    // 通过 Event Bus 进行组件间通信，来折叠侧边栏
    bus.$on('collapse', msg => {
      this.collapse = msg;
    });
  },
  mounted() {
    this.init();
  },
  watch: {
    $route(newV, oldV) {
      this.loginInfo = loginInfoCache.get() || {};
      this.loginTeam = loginTeamCache.get() || {};
      if (oldV.path === '/' || oldV.path === '/account/tj/login' || oldV.path === '/account/login' || oldV.path === '/dashboard') {
        this.init();
      }
    }
  },
  methods: {
    userTypeFilter,
    changed(team) {
      loginTeamCache.set(team);
      location.replace(makeFullURL('/tj/rili'));
    },


    change() {
      this.$refs.teamChoose.open();
    },


    init() {
      const {path} = this.$route;
      if (path === '/') return;
      //this.onRoutes = this.getOnRoutes();
      this.generateMenuList();
      //this.menuList = menuList[this.app] || [];
    },

    generateMenuList() {
      const {staffType} = this.loginInfo;
      const list = menuList[this.app] || [];
      this.menuList = list.filter(menu => {
        if (menu && menu.roles && Array.isArray(menu.roles)) {
          const roles = menu.roles;
          if (roles.includes(staffType)) return true;
          return false;
        }
        return true;
      })
    },

    getOnRoutes() {
      let {path, query, staffOrderInfo} = this.$route;
      if (path !== '/staff/detail') return path;

      // /staff/detail 页面单独处理

      /*else if (query.aspectUser === 'init') return '/staff/faqi';
      else return '/staff/jieshou'*/
    }
  }
}
</script>
